import { buildAuthHeaders } from "../forum/authHeaders";

const IS_LOCAL_FRONTEND =
  typeof window !== "undefined" &&
  ["localhost", "127.0.0.1"].includes(window.location.hostname);
const API_BASE_URL = IS_LOCAL_FRONTEND
  ? process.env.REACT_APP_API_BASE_URL_LOCAL || ""
  : process.env.REACT_APP_API_BASE_URL || "";

export const REWARDS_SUMMARY_ENDPOINT = `${API_BASE_URL}/api/me/rewards/summary/`;

function errorMessage(payload, fallback) {
  if (typeof payload === "string" && payload.trim()) return payload.trim();
  if (payload && typeof payload === "object") {
    return String(payload.detail || payload.error || payload.message || fallback);
  }
  return fallback;
}

async function readPayload(response) {
  const text = await response.text();
  if (!text) return null;
  try {
    return JSON.parse(text);
  } catch (_) {
    return text;
  }
}

function requiredNonNegativeInteger(value, field) {
  const isNumericValue =
    typeof value === "number" ||
    (typeof value === "string" && value.trim() !== "");
  const number = isNumericValue ? Number(value) : Number.NaN;

  if (!Number.isSafeInteger(number) || number < 0) {
    throw new Error(`Résumé Points Eternua invalide : champ « ${field} » manquant ou incorrect.`);
  }
  return number;
}

export function normalizeRewardsSummary(payload) {
  if (!payload || typeof payload !== "object" || Array.isArray(payload)) {
    throw new Error("Résumé Points Eternua invalide.");
  }

  const points = requiredNonNegativeInteger(payload.points, "points");
  const level = requiredNonNegativeInteger(payload.level, "level");
  const activeMissionsCount = requiredNonNegativeInteger(
    payload.active_missions_count,
    "active_missions_count"
  );

  if (level < 1) {
    throw new Error("Résumé Points Eternua invalide : champ « level » manquant ou incorrect.");
  }

  return {
    ...payload,
    points,
    level,
    active_missions_count: activeMissionsCount,
  };
}

export async function fetchRewardsSummary({ signal } = {}) {
  const response = await fetch(REWARDS_SUMMARY_ENDPOINT, {
    method: "GET",
    headers: buildAuthHeaders({ Accept: "application/json" }),
    signal,
  });
  const payload = await readPayload(response);

  if (!response.ok) {
    const error = new Error(
      errorMessage(payload, `Impossible de charger les Points Eternua (${response.status}).`)
    );
    error.status = response.status;
    error.payload = payload;
    throw error;
  }

  return normalizeRewardsSummary(payload);
}
